var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorthArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "568px",
    height: "568px",
    viewBox: "0 0 568 568",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "north_arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.294118 0 0 0 0 0.462745 0 0 0 0 0.647059 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "north_arrow"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.796875, 0.796875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.548437,212.573438 L218.603125,183.10625 L120.117188,118.140625 C119.579688,117.775 118.798438,117.846875 118.310937,118.335938 C117.846875,118.8 117.773438,119.58125 118.140625,120.142188 L183.10625,218.604688 L212.548437,212.573438 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.301562,347.803125 L353.857812,353.857812 L347.803125,383.301562 L446.289062,448.267187 C446.826562,448.657812 447.607812,448.560937 448.095312,448.071875 C448.559375,447.607812 448.632812,446.851562 448.242187,446.289062 L383.301562,347.803125 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.301563,218.603125 L448.267187,120.140625 C448.632812,119.579687 448.560937,118.798437 448.096875,118.334375 C447.607813,117.845312 446.826563,117.773437 446.290625,118.139062 L347.804688,183.104687 L353.859375,212.571875 L383.301563,218.603125 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.10625,347.803125 L118.140625,446.289062 C117.775,446.85 117.846875,447.607812 118.310938,448.071875 C118.8,448.560937 119.58125,448.657812 120.117188,448.267187 L218.603125,383.301562 L212.548438,353.857812 L183.10625,347.803125 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.282812,281.7875 L332.323438,234.082812 L284.61875,1.146875 C284.471875,0.4625 283.885938,0 283.203125,0 C282.520312,0 281.932813,0.4640625 281.7875,1.146875 L234.082812,234.08125 L1.1234375,281.7875 C0.4890625,281.934375 0,282.520312 0,283.203125 C0,283.885938 0.4890625,284.473437 1.1234375,284.61875 L234.082812,332.348438 L281.7875,565.259375 C281.934375,565.94375 282.520312,566.40625 283.203125,566.40625 C283.885938,566.40625 284.473437,565.942187 284.61875,565.259375 L332.323438,332.348438 L565.282812,284.61875 C565.917188,284.471875 566.40625,283.885938 566.40625,283.203125 C566.40625,282.520312 565.91875,281.934375 565.282812,281.7875 Z M283.203125,248.290625 C302.490625,248.290625 318.115625,263.940625 318.115625,283.203125 C318.115625,302.465625 302.490625,318.115625 283.203125,318.115625 C263.915625,318.115625 248.290625,302.465625 248.290625,283.203125 C248.290625,263.940625 263.915625,248.290625 283.203125,248.290625 Z M271.503906,167.9375 L294.941406,206.179688 L294.941406,167.9375 L305.683594,167.9375 L305.683594,225.203125 L294.082031,225.203125 L270.996094,187.859375 L270.996094,225.203125 L260.253906,225.203125 L260.253906,167.9375 L271.503906,167.9375 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthArrow);
export default __webpack_public_path__ + "static/media/north_arrow.e3ff559b3f6b5104eb4f1fb936413486.svg";
export { ForwardRef as ReactComponent };